import { createTheme } from "@mui/material/styles";

import palette from "./palette";
import typography from "./typography";

const theme = createTheme({
  palette,
  typography,
  zIndex: {
    appBar: 1100,
    drawer: 1200,
  },
});

export default theme;
